//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 按需引入部分组件
import { RQ } from 'utils';
import * as F from 'utils/F';
import { dateFormat } from 'utils/filters';
import { yoButton, NavBar } from 'components';
import action from './action';
import { GoodsAction, GoodsActionBigBtn, Button } from 'vant';

export default {
  name: 'coupon',
  props: ['params'],
  metaInfo: {
    title: '开通超级会员'
  },
  created: async function () {
    this.getTipInfo();
  },
  updated() {
    console.log(this.popupVisible1);
  },
  data() {
    // const tipInfo = JSON.parse(localStorage.getItem('tipInfo'))
    return {
      enterprise: this.params.enterprise,
      tipInfo: {}
    };
  },
  computed: {},
  filters: {
    dateFormat
  },
  components: {
    yoButton,
    NavBar,
    GoodsAction,
    GoodsActionBigBtn,
    'van-button': Button
  },
  methods: {
    ...action
  }
};



// WEBPACK FOOTER //
// ./src/module/vip/paySuccess/page.vue